import { render, staticRenderFns } from "./ProductsInStock.vue?vue&type=template&id=dfbefd54&scoped=true"
import script from "./ProductsInStock.vue?vue&type=script&lang=js"
export * from "./ProductsInStock.vue?vue&type=script&lang=js"
import style0 from "./ProductsInStock.vue?vue&type=style&index=0&id=dfbefd54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbefd54",
  null
  
)

export default component.exports